export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ../~/_rc-pagination@1.20.7@rc-pagination/es/index.js
// module id = 137
// module chunks = 0